import React, { Component } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import 'react-block-ui/style.css';
import SignalRService from '../../controllers/SignalRService';
import CryptoJS from 'crypto-js';
import { connect } from 'react-redux';
import { compose } from 'redux';

class ChangePassword extends Component {

    constructor(props) {
        super(props)

        this.state = {
            oldPwd: "",
            isEmptyOldPwd: false,
            newPwd: "",
            isEmptyNewPwd: false,
            oldAndNewMatch: false,
            invalidPwdPolicy: false,
            cnfpwd: "",
            doesNotMatchNewPwd: false
        }

        this.setOldPwd = this.setOldPwd.bind(this);
        this.setNewPwd = this.setNewPwd.bind(this);
        this.setCnfPwd = this.setCnfPwd.bind(this);
        this.changePwd = this.changePwd.bind(this);
    }

    setOldPwd(e) {
        e.preventDefault();
        this.setState({
            oldPwd: e.target.value,
            isEmptyOldPwd: e.target.value === null || (e.target.value !== null && e.target.value.trim() === "")
        });
    }

    setCnfPwd(e) {
        e.preventDefault();
        this.setState({
            cnfpwd: e.target.value,
            doesNotMatchNewPwd: e.target.value !== this.state.newPwd
        });
    }

    setNewPwd(e) {
        e.preventDefault();
        let invalidPwdPolicy = false;

        if (this.props.passwordPolicy) {
            invalidPwdPolicy = !new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z][^*]{7,}$/).test(e.target.value)
        }

        this.setState({
            newPwd: e.target.value,
            isEmptyNewPwd: e.target.value === null || (e.target.value !== null && e.target.value.trim() === ""),
            doesNotMatchNewPwd: e.target.value !== this.state.cnfpwd,
            oldAndNewMatch: e.target.value === this.state.oldPwd,
            invalidPwdPolicy: invalidPwdPolicy
        });
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    changePwd = e => {
        let isEmptyOldPwd = this.state.oldPwd === null || (this.state.newPwd !== null && this.state.oldPwd.trim() === ""),
            isEmptyNewPwd = this.state.newPwd === null || (this.state.newPwd !== null && this.state.newPwd.trim() === ""),
            oldAndNewMatch = this.state.newPwd === this.state.oldPwd,
            doesNotMatchNewPwd = this.state.newPwd !== this.state.cnfpwd,
            invalidPwdPolicy = false;

        if (this.props.passwordPolicy) {
            invalidPwdPolicy = !new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z][^*]{7,}$/).test(this.state.newPwd)
        }

        if (!isEmptyOldPwd && !isEmptyNewPwd && !oldAndNewMatch && !doesNotMatchNewPwd && !invalidPwdPolicy) {
            let data = {
                "extension": this.props.extension,
                "userId": this.props.userId,
                "oldPassword": CryptoJS.SHA512(this.state.oldPwd).toString(),
                "newPassword": CryptoJS.SHA512(this.state.newPwd).toString(),
            };
            localStorage.removeItem("faChangePwd");
            SignalRService.setUserPassword(data);
            let userData = JSON.parse(localStorage.getItem("fc-logged"));
            userData.password = data.newPassword;
            let dataStr = JSON.stringify(userData);
            localStorage.setItem("fc-logged", dataStr);
            this.props.toggleModal();
        } else {
            this.setState({
                isEmptyOldPwd: isEmptyOldPwd,
                isEmptyNewPwd: isEmptyNewPwd,
                oldAndNewMatch: oldAndNewMatch,
                doesNotMatchNewPwd: doesNotMatchNewPwd,
                invalidPwdPolicy: invalidPwdPolicy
            });
        }
    }

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg" backdrop={this.props.changePassword ? "static" : true}>
                    {
                        !this.props.changePassword &&
                        <Modal.Header>
                            <Modal.Title><FontAwesomeIcon icon={duotone("key")} /> {this.props.t("changepassword")}</Modal.Title>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("close")}
                                </Tooltip>}>
                                <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                            </OverlayTrigger>
                        </Modal.Header>

                    }
                    {
                        this.props.changePassword &&
                        <Modal.Header>
                            <Modal.Title><FontAwesomeIcon icon={duotone("key")} /> {this.props.t("changepassword")}</Modal.Title>
                        </Modal.Header>
                    }

                    <Modal.Body>
                        <Row>
                            <Col>
                                <Form>
                                    <Form.Group className="mb-4" controlId="fcoldpwd" hasValidation>
                                        <Form.Label>{this.props.t("oldpwd")}</Form.Label>
                                        <Form.Control type="password" value={this.state.oldPwd} onChange={this.setOldPwd} isInvalid={this.state.isEmptyOldPwd} />
                                        <Form.Text className="text-muted">
                                        </Form.Text>

                                        {
                                            (this.state.isEmptyOldPwd) &&
                                            <Form.Text id="passwordHelpBlock" className='text-danger'>
                                                {this.props.t("oldpasswordisempty")}
                                            </Form.Text>
                                        }

                                    </Form.Group>
                                    <Form.Group className="mb-4" controlId="fcnewpwd" hasValidation>
                                        <Form.Label >{this.props.t("newpwd")}</Form.Label>
                                        <Form.Control type="password" value={this.state.newPwd} onChange={this.setNewPwd} isInvalid={this.state.isEmptyNewPwd || this.state.oldAndNewMatch || this.state.invalidPwdPolicy} />
                                        <Form.Text className="text-muted">
                                        </Form.Text>

                                        {
                                            (this.state.isEmptyNewPwd) &&
                                            <Form.Text className='text-danger'>
                                                {this.props.t("newpasswordisempty")}
                                            </Form.Text>
                                        }
                                        {
                                            (this.state.oldAndNewMatch) &&
                                            <Form.Text className='text-danger'>
                                                {this.props.t("oldandnewpwdmatch")}
                                            </Form.Text>
                                        }
                                        {
                                            (this.state.invalidPwdPolicy) &&
                                            <Form.Text className='text-danger'>
                                                {this.props.t("newpwdmismatchpolicy")}
                                            </Form.Text>
                                        }
                                    </Form.Group>
                                    <Form.Group className="mb-4" controlId="fccnfpwd" hasValidation>
                                        <Form.Label>{this.props.t("cnfpwd")}</Form.Label>
                                        <Form.Control type="password" value={this.state.cnfpwd} onChange={this.setCnfPwd} isInvalid={this.state.doesNotMatchNewPwd} />
                                        <Form.Text className="text-muted">
                                        </Form.Text>

                                        {
                                            (this.state.doesNotMatchNewPwd) &&
                                            <Form.Text id="passwordHelpBlock" className='text-danger'>
                                                {this.props.t("passworddoesnotmatch")}
                                            </Form.Text>
                                        }
                                    </Form.Group>
                                </Form>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.changePwd}>
                            <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("send")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        changePassword: state.parameters.changePassword,
        passwordPolicy: state.parameters.passwordPolicy
    };
};
export default compose(connect(mapStateToProps, {}), withTranslation())(ChangePassword);